import React from 'react';
import { createElement } from 'react';
import classnames from 'classnames';
import './style.less';
Switch.defaultProps = {
    disabled: false,
    size: 'normal',
    defaultChecked: false,
};
const PREFIX_CLASS = 'im-switch';
function Switch(props) {
    const { checked: propsChecked, disabled, size, onChange, defaultChecked } = props;
    const isControlled = propsChecked !== undefined;
    const [internalChecked, setInternalChecked] = React.useState(defaultChecked);
    const checked = isControlled ? propsChecked : internalChecked;
    const handleClick = (e) => {
        e.preventDefault();
        if (disabled || !onChange)
            return;
        const newChecked = !checked;
        if (!isControlled) {
            setInternalChecked(newChecked);
        }
        onChange(newChecked);
    };
    const classNames = classnames(PREFIX_CLASS, {
        [`${PREFIX_CLASS}-checked`]: checked,
        [`${PREFIX_CLASS}-disabled`]: disabled,
        [`${PREFIX_CLASS}-small`]: size === 'small',
    });
    return (createElement("div", { className: classNames, onClick: handleClick, role: "switch", "aria-checked": checked, "aria-disabled": disabled },
        createElement("div", { className: `${PREFIX_CLASS}-dot` })));
}
export default Switch;
